import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DiseaseMapping from "../components/DiseaseMapping";


const AddUserPage = () => {
  return (
    <>
      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Crop Disease Mapping" />

        {/* AddUserLayer */}
        <DiseaseMapping />


      {/* </MasterLayout> */}
    </>
  );
};

export default AddUserPage;
